import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/core-service/services/core-service.service';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-smart-menu',
  templateUrl: './smart-menu.component.html',
  styleUrls: ['./smart-menu.component.scss']
})
export class SmartMenuComponent implements OnInit, OnChanges {
  assetsUrl = '';
  @Output()
  onListClickEmit = new EventEmitter();
  @Output()
  onHomeEmit = new EventEmitter();
  @Output()
  onPortalEmit = new EventEmitter();
  @Output()
  onCoreEmit = new EventEmitter();
  imgSrc: string = environment.assetsUrl + "noun_manager_3156289.png";
  imgSrcWeb: string = environment.assetsUrl + "noun_website_1757933.png";
  coreImg : string = environment.assetsUrl + "core-img.png";
  homeSrc : string = environment.assetsUrl + 'Icon-metro-home.png';
  isPortalManagerClicked: boolean = false;
  portalClicked: boolean = false;
  isWebsiteAndListingClicked: boolean = false;
  isHomeClicked: boolean = false;
  clickHome: boolean = false;
  isCoreServiceClicked: boolean = false;
  clickCoreServiceMenu: boolean = false
  isBranchAdminUser: boolean = false;
  isOfficeManagerSearchClicked = false;
  isOnManageClicked = false;
  isCoreManageClicked = false;
  @Output()
  closeHeaderPopup = new EventEmitter(); 
  @Input() showCoreAssociationModule = false;
  isLOBUser: boolean = false;
  @Output() onLogoClick = new EventEmitter();
  @ViewChild('homeClickModal', {static: true})
  public homeClickModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('portalClickModal', {static: true})
  public portalClickModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('coreClickModal', {static: true})
  public coreClickModal: SearchUpdateConfirmationComponent | any;
  constructor(private router: Router,
     private commonService:CommonService,
     private coreService: CoreService) {
    //blank constructor
  }


  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
    this.isBranchAdminUser = this.commonService.isBranchAdminUser();
    this.isLOBUser =  this.commonService.isLOBUser();
    this.isOfficeManagerSearchClicked = this.commonService.getOfficeManagerAgentSitesClick();
    this.isOnManageClicked = this.commonService.getOnManageClick();
    this.isCoreManageClicked = this.commonService.getOnCoreManageClick();
  }


  ngOnChanges() {
    if(this.showCoreAssociationModule) {
        this.coreImg = environment.assetsUrl + "core-menu-blue.png";
      this.isPortalManagerClicked = false;
      this.isCoreServiceClicked = true;
    } else {
      this.isCoreServiceClicked = false;
      this.isPortalManagerClicked = true;
      this.imgSrc = environment.assetsUrl + "portal-mngr-blue.png";
    }
  }


  /**
   * on click of Website and listing Menu
   */
  onListClick(event: any) {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    this.onListClickEmit.emit(event);
    if(this.isPortalManagerClicked === true){
      this.imgSrc = this.assetsUrl + "portal-mngr-blue.png";
    }else if(this.isCoreServiceClicked === true){
      this.coreImg = this.assetsUrl + "core-menu-blue.png";
    }   
  }


  /**
  * on click of Home Menu
  */
  onHomeClick(_event: any) {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    if(this.commonService.getFormUpdateStatus()) {
      this.homeClickModal.showModal();
    } else {
      this.onHomeClickConfirm();
    }
  }

  onHomeClickConfirm() {    
    this.commonService.setHomePageFlag(true);
    this.commonService.goToCoreServiceFromPortal(false);
    // To be checked once all the scenarios are implementes
    if (this.commonService.getOfficeManagerAgentSitesClick() && this.commonService.isOfficeManagerUser()) {
      setTimeout(() => {
        this.closeHeaderPopup.emit(true)
      }, 100);
      this.commonService.setOfficeManagerAgentSitesClick(false);
      this.commonService.setLastAgentSearchDetails(undefined);
      this.commonService.officeManagerAgentSearchClick$.next(false);
    } else {
      if(this.router.url === '/portal') {
        this.commonService.gotoHomeEvent.next(true);
      } else if(this.router.url === '/portal/core-service/nonEmployeeProfile'){
        this.router.navigate(['/portal']);
      }else {
        this.closeHeaderPopup.emit(true)
        this.router.navigate(['/portal']);
      }
    }
    
    this.commonService.setClickNonEmployeeEvent(false);
    this.isHomeClicked = true;
    this.commonService.setFormUpdateStatus(false);
  }


  /**
  * on click of Portal Manager Menu
  */
  onPortalManagerClick(_event: any) {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    if(this.commonService.getFormUpdateStatus()) {
      this.portalClickModal.showModal();
    } else {
      this.onPortalClickConfirm();
    }
  }

  onPortalClickConfirm() {
    this.commonService.setHomePageFlag(false);
    this.commonService.setFormUpdateStatus(false);
    this.imgSrc = this.assetsUrl + "portal-mngr-blue.png";
    this.coreImg = this.assetsUrl + "core-img.png";
    this.isPortalManagerClicked = true;
    this.clickCoreServiceMenu = false;
    this.isWebsiteAndListingClicked = false;
    this.isCoreServiceClicked = false;
    this.closeHeaderPopup.emit(true);
    this.commonService.setEnablePortalClick(false);
    this.commonService.setClickNonEmployeeEvent(false)
    this.commonService.goToCoreServiceFromPortal(false);
    if (this.router.url !== '/portal') {
      this.portalClicked = true;
      this.commonService.goToPortalFromCore(true);
      this.router.navigate(['/portal']);      

    } else if(this.router.url === '/portal') {      
      this.commonService.gotoPortalSearchFromCoreModule.next(true);
    }  
  }

  /**
  * on click of Portal Manager Menu
  */
   onCoreServiceClick(_event: any) {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    sessionStorage.setItem('coreServiceFromPortal', 'true');
    if(this.commonService.getFormUpdateStatus()) {
      this.coreClickModal.showModal();
    } else {
      this.onCoreServiceClickConfirm();
    }
   }

   onCoreServiceClickConfirm() {
    this.commonService.setHomePageFlag(false);
    this.commonService.setClickNonEmployeeEvent(false);
    this.commonService.setFormUpdateStatus(false);
    this.coreImg = this.assetsUrl + "core-menu-blue.png";
    this.imgSrc = this.assetsUrl + "noun_manager_3156289.png";
    this.isPortalManagerClicked = false;
    this.portalClicked = false;
    this.closeHeaderPopup.emit(true);
    this.isWebsiteAndListingClicked = false;
    this.isCoreServiceClicked = true;
    if (this.router.url !== '/portal') {
      this.clickCoreServiceMenu = true;
      this.commonService.goToCoreServiceFromPortal(true);
      this.router.navigate(['/portal']);
    } else if (this.router.url === '/portal') {
      this.onCoreEmit.emit(true);
    }    
    this.commonService.setEnablePortalClick(true);
   }

}
